import { render, staticRenderFns } from "./FormMessages.vue?vue&type=template&id=a7dfdfa8&scoped=true&"
import script from "./FormMessages.vue?vue&type=script&lang=ts&"
export * from "./FormMessages.vue?vue&type=script&lang=ts&"
import style0 from "./FormMessages.vue?vue&type=style&index=0&id=a7dfdfa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dfdfa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFadeTransition,VIcon,VRow})
